import { Stack } from "@mui/material";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { useCreateLiveActivityForUpcomingShift } from "@src/appV2/LiveActivity/useCreateLiveActivityForUpcomingShift";
import { convertFromGoogleMapsLocation } from "@src/appV2/Location";
import { EnforceLocationPermissionsContainer } from "@src/appV2/LocationPermission/EnforceLocationPermissionsContainer";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { USER_EVENTS } from "@src/constants";

import { isWorkerInviteRequired } from "../../ClipboardScore/utils/utils";
import { GoogleMapErrorBoundary } from "../../GeoLocation/GoogleMapErrorBoundary";
import { useGeoLocationFromUrlParams } from "../../GeoLocation/useGeoLocationFromUrlParams";
import { InviteRequiredPage } from "../InviteRequired/Page";
import { ShiftDiscoveryPageHeader } from "../PageHeader";
import { ShiftDiscoverySearchModeSwitcher } from "../SearchModeSwitcher";
import { ShiftDiscoveryMap } from "./ShiftDiscoveryMap";
import { useMapViewWorkplacesData } from "./useMapViewWorkplacesData";
import { useWorkerLocations } from "./useWorkerLocations";

export function ShiftDiscoveryMapViewPage() {
  const { geoLocation: geoLocationFromUrlParams } = useGeoLocationFromUrlParams();

  const { workerLocation } = useWorkerLocations();

  const workerGeoLocation = workerLocation
    ? convertFromGoogleMapsLocation(workerLocation)
    : undefined;

  const currentGeoLocation = geoLocationFromUrlParams ?? workerGeoLocation;

  const {
    data: { priorityShiftsCount, urgentShiftsCount, blockShiftsCount },
  } = useMapViewWorkplacesData({
    geoLocation: currentGeoLocation,
  });

  useCreateLiveActivityForUpcomingShift();
  useLogEffect(USER_EVENTS.VIEW_OPEN_SHIFT_MAP, { trigger: "pageLoad" });

  const worker = useDefinedWorker();
  const isInviteRequired = isWorkerInviteRequired(worker);

  if (isInviteRequired) {
    return <InviteRequiredPage />;
  }

  return (
    <Stack
      sx={(theme) => ({
        flex: 1,
        backgroundColor: theme.palette.background.tertiary,
        overflow: "hidden",
        position: "relative",
      })}
    >
      <EnforceLocationPermissionsContainer />
      <ShiftDiscoveryPageHeader
        priorityShiftsCount={priorityShiftsCount}
        urgentShiftsCount={urgentShiftsCount}
        blockShiftsCount={blockShiftsCount}
      />

      <GoogleMapErrorBoundary>
        <ShiftDiscoveryMap />
      </GoogleMapErrorBoundary>

      <ShiftDiscoverySearchModeSwitcher />
    </Stack>
  );
}
